import React, { useState, useEffect } from "react";
import { Toast } from "../../CustomComponent/toast";
import CustomInput from "../../CustomComponent/custom_input";
import FormSubmitButton from "../../Components/layouts/formSubmitButton";
import SimpleButton from "../../Components/layouts/simple_button";
import performRequest from "../../api/request";
import { Form, Formik } from "formik";
import CustomTextArea from "../../CustomComponent/custom_textarea";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
// import { enquiryInfo } from "../../SchemaInfo/enquiryInfo";
import { createVendorBuyOrderInfo } from "../../SchemaInfo/info";
import { vendorBuyOrder } from "../../Schemas/buyers/vendor_buy_order_schema";
import Footer from "../../Components/Footer/footer";
import CustomSelect from "../../CustomComponent/custom_select";
import { useSelector } from "react-redux";

const CreateVendorBuyOrderForm = () => {
  const [loading, setLoading] = useState(false);
  const store = useSelector((store) => store.login.user);
  const [activeField, setActiveField] = useState("preferredLanguage");
  const today = new Date();
  const maxDate = new Date(today);
  maxDate.setDate(today.getDate() + 30);
  const [plantList, setPlantList] = useState();
  const [selectedImage, setSelectedImage] = useState("");

  const indiaStates = [
    { label: "Select State", value: "" },
    { label: "Andhra Pradesh", value: "Andhra Pradesh" },
    { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
    { label: "Assam", value: "Assam" },
    { label: "Bihar", value: "Bihar" },
    { label: "Chhattisgarh", value: "Chhattisgarh" },
    { label: "Goa", value: "Goa" },
    { label: "Gujarat", value: "Gujarat" },
    { label: "Haryana", value: "Haryana" },
    { label: "Himachal Pradesh", value: "Himachal Pradesh" },
    { label: "Jharkhand", value: "Jharkhand" },
    { label: "Karnataka", value: "Karnataka" },
    { label: "Kerala", value: "Kerala" },
    { label: "Madhya Pradesh", value: "Madhya Pradesh" },
    { label: "Maharashtra", value: "Maharashtra" },
    { label: "Manipur", value: "Manipur" },
    { label: "Meghalaya", value: "Meghalaya" },
    { label: "Mizoram", value: "Mizoram" },
    { label: "Nagaland", value: "Nagaland" },
    { label: "Odisha", value: "Odisha" },
    { label: "Punjab", value: "Punjab" },
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Sikkim", value: "Sikkim" },
    { label: "Tamil Nadu", value: "Tamil Nadu" },
    { label: "Telangana", value: "Telangana" },
    { label: "Tripura", value: "Tripura" },
    { label: "Uttar Pradesh", value: "Uttar Pradesh" },
    { label: "Uttarakhand", value: "Uttarakhand" },
    { label: "West Bengal", value: "West Bengal" },
    { label: "Delhi", value: "Delhi" },
    { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
    { label: "Ladakh", value: "Ladakh" },
  ];

  useEffect(() => {
    performRequest("GET", "/agronomyWiki/getAllAgronomyWiki/")
      .then((res) => {
        if (res.status === 200) {
          setPlantList(res?.data?.data);
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const handelSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true);
  
      let finalDeadline = "";
      const today = new Date();
  
      const getISTDate = (date) => {
        return new Date(date.getTime() + 5.5 * 60 * 60 * 1000)
          .toISOString()
          .split("T")[0];
      };
  
      switch (values.requirementDeadline) {
        case "today":
          finalDeadline = getISTDate(today);
          break;
  
        case "tomorrow":
          const tomorrow = new Date();
          tomorrow.setDate(today.getDate() + 1);
          finalDeadline = getISTDate(tomorrow);
          break;
  
        case "week":
          const week = new Date();
          week.setDate(today.getDate() + 7);
          finalDeadline = getISTDate(week);
          break;
  
        case "month":
          const month = new Date();
          month.setMonth(today.getMonth() + 1);
          finalDeadline = getISTDate(month);
          break;
  
        case "3months":
          const threeMonths = new Date();
          threeMonths.setMonth(today.getMonth() + 3);
          finalDeadline = getISTDate(threeMonths);
          break;
  
        case "custom":
          finalDeadline = values.customDeadlineDate;
          break;
  
        default:
          break;
      }
  
      const finalData = {
        ...values,
        requirementDeadline: finalDeadline,
      };
  
      // ✅ API CALL
      const response = await performRequest(
        "POST",
        "/vendorBuyOrder/createVendorBuyOrder",
        finalData
      );
  
      if (response.status === 200 || response.status === 201) {
        Toast("success", "Vendor Buy Order Created Successfully!");
        resetForm();
      } else {
        Toast("error", "Failed to create Vendor Buy Order!");
      }
    } catch (error) {
      CustomErrorResponse(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="col-12 ">
              <div className="card my-4">
                <div className="card-header">
                  <h3 className="page-title">
                    Please provide enquiry details below.
                  </h3>
                </div>
                <Formik
                  initialValues={createVendorBuyOrderInfo}
                  validationSchema={vendorBuyOrder}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <>
                      {/* <div className="row"> */}
                      <div className="row justify-content-center">
                        {/* <div className="col-12 col-md-3 col-lg-3 m-md-3 m-lg-3 m-0">
                          <div
                            className="card mx-2"
                            style={{
                              position: "sticky",
                              top: "100px",
                              maxHeight: "80vh",
                              overflowY: "auto",
                            }}
                          >
                            <div className="">
                              <div className=" text-center p-1">
                                <h2>CRM Script</h2>
                              </div>
                            </div>
                            <hr className="m-0 p-0"></hr>

                            <div className="card-body">
                              {props.values.preferredLanguage ? (
                                <>
                                  <p
                                    style={{
                                      whiteSpace: "pre-line",
                                      fontSize: "16px",
                                    }}
                                  >
                                    {crmScripts[activeField]?.[
                                      props.values.preferredLanguage
                                    ] || "No script available for this field"}
                                  </p>
                                </>
                              ) : (
                                <p className="text-muted">
                                  Select language first to see CRM script
                                </p>
                              )}
                            </div>
                          </div>
                        </div> */}

                        <div className="col-12 col-md-8 col-lg-8 m-md-3 m-lg-3 m-0 border">
                          <Form>
                            <div className="card-body">
                              {/* First Name */}
                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vendor Name
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="vendorName" type="text" />
                                  {props.touched.vendorName &&
                                    props.errors.vendorName && (
                                      <p className="text-danger">
                                        {props.errors.vendorName}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vendor Address
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="vendorAddress"
                                    type="text"
                                  />
                                  {props.touched.vendorAddress &&
                                    props.errors.vendorAddress && (
                                      <p className="text-danger">
                                        {props.errors.vendorAddress}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label text-start col-3">
                                  Vendor State
                                </label>
                                <div className="w-100 col">
                                  <select
                                    className="form-control"
                                    name="vendorState"
                                    value={props.values.vendorState}
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "vendorState",
                                        e.target.value
                                      );
                                    }}
                                  >
                                    {indiaStates.map((s) => (
                                      <option key={s?.label} value={s?.value}>
                                        {s?.label}
                                      </option>
                                    ))}
                                  </select>
                                  {props.touched.vendorState &&
                                    props.errors.vendorState && (
                                      <p className="text-danger">
                                        {props.errors.vendorState}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Pincode
                                </label>
                                <div className="w-100 col">
                                  <CustomInput name="pincode" type="text" />
                                  {props.touched.pincode &&
                                    props.errors.pincode && (
                                      <p className="text-danger">
                                        {props.errors.pincode}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Contact Number
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="contactNumber"
                                    type="text"
                                  />
                                  {props.touched.contactNumber &&
                                    props.errors.contactNumber && (
                                      <p className="text-danger">
                                        {props.errors.contactNumber}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Crop Name
                                </label>
                                <div className="w-100 col">
                                  <CustomSelect
                                    name="cropName"
                                    onChange={(e) => {
                                      const selectedValue = e.target.value;
                                      const selectedPlant = plantList.find(
                                        (plant) => plant.name === selectedValue
                                      );
                                      if (selectedPlant) {
                                        const imageUrl = selectedPlant.image;
                                        setSelectedImage(imageUrl);
                                        props.setFieldValue(
                                          "cropPhoto",
                                          imageUrl
                                        );
                                      }
                                      props.setFieldValue(
                                        "cropName",
                                        selectedValue
                                      );
                                    }}
                                  >
                                    <option value="">Select</option>
                                    {plantList &&
                                      plantList.map((plant) => (
                                        <option
                                          key={plant.id}
                                          value={plant.name}
                                        >
                                          {plant.name}
                                        </option>
                                      ))}
                                  </CustomSelect>

                                  {props.touched.cropName &&
                                    props.errors.cropName && (
                                      <p className="text-danger">
                                        {props.errors.cropName}
                                      </p>
                                    )}
                                  {selectedImage && (
                                    <div className="mt-3">
                                      <img
                                        src={selectedImage}
                                        alt="Selected Crop"
                                        style={{ width: "100px" }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vendor Offer Price Per KG
                                </label>
                                <div className="w-100 col">
                                  <CustomInput
                                    name="vendorOfferPricePerKg"
                                    type="text"
                                  />
                                  {props.touched.vendorOfferPricePerKg &&
                                    props.errors.vendorOfferPricePerKg && (
                                      <p className="text-danger">
                                        {props.errors.vendorOfferPricePerKg}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Vendor Requirement
                                </label>
                                <div className="w-100 col">
                                  <div className="d-flex gap-2">
                                    {/* Quantity Input */}
                                    <div style={{ flex: 2 }}>
                                      <CustomInput
                                        name="vendorRequirement"
                                        type="number"
                                        placeholder="Enter quantity"
                                      />
                                    </div>

                                    {/* Unit Dropdown */}
                                    <div style={{ flex: 1 }}>
                                      <select
                                        className="form-control"
                                        name="vendorRequirementUnit"
                                        value={
                                          props.values.vendorRequirementUnit
                                        }
                                        onChange={(e) =>
                                          props.setFieldValue(
                                            "vendorRequirementUnit",
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="Kg">Kg</option>
                                        <option value="Ton">Ton</option>
                                        <option value="Gram">Gram</option>
                                        <option value="Quintal">Quintal</option>
                                      </select>
                                    </div>
                                  </div>

                                  {/* Error Handling */}
                                  {props.touched.vendorRequirement &&
                                    props.errors.vendorRequirement && (
                                      <p className="text-danger">
                                        {props.errors.vendorRequirement}
                                      </p>
                                    )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Requirement Deadline
                                </label>

                                <div className="w-100 col">
                                  {/* Dropdown */}
                                  <select
                                    className="form-control"
                                    name="requirementDeadline"
                                    value={props.values.requirementDeadline}
                                    onChange={(e) => {
                                      props.setFieldValue(
                                        "requirementDeadline",
                                        e.target.value
                                      );

                                      // reset custom date when changing option
                                      if (e.target.value !== "custom") {
                                        props.setFieldValue(
                                          "customDeadlineDate",
                                          ""
                                        );
                                      }
                                    }}
                                  >
                                    <option value="">Select</option>
                                    <option value="today">Today</option>
                                    <option value="tomorrow">Tomorrow</option>
                                    <option value="week">Within a Week</option>
                                    <option value="month">
                                      Within a Month
                                    </option>
                                    <option value="3months">
                                      Within 3 Months
                                    </option>
                                    <option value="custom">Custom Date</option>
                                  </select>

                                  {/* Error */}
                                  {props.touched.requirementDeadline &&
                                    props.errors.requirementDeadline && (
                                      <p className="text-danger">
                                        {props.errors.requirementDeadline}
                                      </p>
                                    )}

                                  {/* Show Date Picker ONLY if Custom selected */}
                                  {props.values.requirementDeadline ===
                                    "custom" && (
                                    <div className="mt-3">
                                      <input
                                        type="date"
                                        className="form-control"
                                        name="customDeadlineDate"
                                        value={props.values.customDeadlineDate}
                                        min={
                                          new Date().toISOString().split("T")[0]
                                        } // disable past dates
                                        onChange={(e) =>
                                          props.setFieldValue(
                                            "customDeadlineDate",
                                            e.target.value
                                          )
                                        }
                                      />

                                      {props.touched.customDeadlineDate &&
                                        props.errors.customDeadlineDate && (
                                          <p className="text-danger">
                                            {props.errors.customDeadlineDate}
                                          </p>
                                        )}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="mb-3 row">
                                <label className="w-25 form-label col-3">
                                  Repetitive Order
                                </label>

                                <div className="w-100 col d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    name="repativeOrder"
                                    checked={props.values.repativeOrder}
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "repativeOrder",
                                        e.target.checked
                                      )
                                    }
                                    style={{ width: "18px", height: "18px" }}
                                  />

                                  {/* <span className="ms-2">
      {props.values.repativeOrder ? "Yes" : "No"}
    </span> */}
                                </div>

                                {props.touched.repativeOrder &&
                                  props.errors.repativeOrder && (
                                    <p className="text-danger">
                                      {props.errors.repativeOrder}
                                    </p>
                                  )}
                              </div>
                            </div>
                            {/* Form Actions */}
                            <div className="card-footer">
                              <div className="btn-list justify-content-end">
                                <FormSubmitButton buttonText="Submit Order" />
                                <SimpleButton
                                  buttonText="Cancel"
                                  type="secondary"
                                />
                              </div>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default CreateVendorBuyOrderForm;
